interface Props {
    page: number;
    totalPages: number;
    totalCount: number;
    isFetching: boolean;
    onPageChange: (page: number) => void;
}

const Pagination = ({ page, totalPages, totalCount, isFetching, onPageChange }: Props) => (
    <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">
            {totalCount} entrée{totalCount > 1 ? 's' : ''} — page {page} / {totalPages}
        </small>

        <ul className="pagination mb-0">
            <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => onPageChange(page - 1)} disabled={page <= 1 || isFetching}>
                    ‹ Précédent
                </button>
            </li>

            {Array.from({ length: totalPages }, (_, i) => i + 1)
                .filter((p) => Math.abs(p - page) <= 2)
                .map((p) => (
                    <li key={p} className={`page-item ${p === page ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => onPageChange(p)} disabled={isFetching}>
                            {p}
                        </button>
                    </li>
                ))}

            <li className={`page-item ${page >= totalPages ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages || isFetching}>
                    Suivant ›
                </button>
            </li>
        </ul>
    </div>
);

export default Pagination;
